import LevelResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/Level/LevelResponse";
import LevelTranslationsUpdateRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/Level/LevelTranslationsUpdateRequest";
import UpdateLevelRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/Level/UpdateLevelRequest";
import TranslationItemModel from "@models/translationItemModel";

export class UpdateLevelModel {
  id?: number = null;
  numberOfMinutes?: number;
  translations: Array<TranslationItemModel> = null;

  initLanguages(languages: string[]) {
    this.translations = languages.map(
      (x) =>
        new TranslationItemModel({
          langCode: x,
        })
    );
  }

  toServerModel(): UpdateLevelRequest {
    return new UpdateLevelRequest({
      LevelId: this.id,
      NumberOfMinutes: this.numberOfMinutes,
      Translations: this.translations.map(
        (x) =>
          new LevelTranslationsUpdateRequest({
            LangCode: x.langCode,
            Name: x.name,
          })
      ),
    });
  }

  fromServerModel(model: LevelResponse) {
    this.id = model.Id;
    this.numberOfMinutes = model.NumberOfMinutes;
    this.translations.forEach((tr) => {
      const serverTranslation = model.Translations.find(
        (x) => x.LangCode == tr.langCode
      );
      if (serverTranslation != null) {
        tr.name = serverTranslation.Name;
      }
    });
  }
}
